export const generateRedirectUrl = ({
  host,
  path = '',
  redmineToken,
  isWithAuth = false,
  skipRedirection = false,
  backUrl,
}) => {
  const redmineHost = window.APP_CONFIG.env.REDMINE_HOST;

  const newBackUrl = backUrl ? backUrl : '';

  return `${redmineHost}${path}${isWithAuth ? `/my/auth?api_auth_token=${redmineToken}` : ''}${
    isWithAuth ? '&' : '?'
  }incoming_url=${window.location.origin}${newBackUrl !== '' ? `&back_url=${newBackUrl}` : ''}${
    skipRedirection ? '&X-Lance-Skip-Redirection=true' : ''
  }`;
};
